import React from "react";
import { styled } from "@linaria/react";
import t from "../../../../../../i18n";
import { color, fonts } from "@ui";
import { HIDE_ON_EXPORT } from "@ui/lib/downloadPage";
import { ToolsFill } from "@ui/IconV2/react";
import classNames from "classnames";
import type { Translation } from "../../../../../../api/useTranslations";
import type { Reparability } from "../../../../../../api/Reparability";
import { REPARABILITY_COLOR } from "../../../../../../api/Reparability";

interface P extends React.HTMLAttributes<HTMLDivElement> {
  reparability: Reparability;
  translations: Translation;
}

const ToolWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const getClassNameColor = (reparability: Reparability) => {
  switch (reparability) {
    case "REPARABILITY_0":
      return "green";
    case "REPARABILITY_1":
      return "orange";
    case "REPARABILITY_2":
      return "red";
    default:
      throw new Error(reparability satisfies never);
  }
};

const StyledReparabilityTag = styled.div`
  display: inline-flex;
  /* justify-content: center; */
  align-items: center;
  max-width: fit-content;
  gap: 8px;
  font: ${fonts.body3};
  border-radius: 100px;
  padding: 4px 8px;
  color: ${color.carbon100};
  &.green {
    background-color: ${REPARABILITY_COLOR.REPARABILITY_0};
  }
  &.orange {
    background-color: ${REPARABILITY_COLOR.REPARABILITY_1};
  }
  &.red {
    background-color: ${REPARABILITY_COLOR.REPARABILITY_2};
  }

  span {
    word-break: keep-all;
    white-space: nowrap;
  }
`;

//NOTE : Unable to use Badge component with renderToString due to CSP constraint violation
const ReparabilityTag = ({ reparability, translations }: P) => (
  <StyledReparabilityTag className={classNames(getClassNameColor(reparability))}>
    <ToolWrapper className={HIDE_ON_EXPORT}>
      <ToolsFill size="s" />
    </ToolWrapper>
    <span>{t("reparability", reparability, translations)}</span>
  </StyledReparabilityTag>
);
export default ReparabilityTag;
